var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "./context";
import { authRedirectURL, returnPathQueryKey, tokenQueryKey, } from "authentication/constants";
import { PageRoute } from "utility/url";
export var AuthGuard = function (_a) {
    var Component = _a.Component;
    var isAuthenticated = useAuthContext().isAuthenticated;
    return isAuthenticated ? _jsx(Component, {}) : _jsx(AuthWithRedirect, {});
};
// When user is not authenticated, this component will prepare a returnUrl query param to send
// to the auth-url at piab.com which piab will redirect the user back to after a successfull login.
// A JWT-token will be appended to the return URL by piab as a query param.
var AuthWithRedirect = function () {
    var _a = window.location, origin = _a.origin, urlPath = _a.pathname /* We need pathname from location when running on dev.animech.com to ensure we append "/piab" to the return url */;
    var _b = useLocation(), search = _b.search, pathname = _b.pathname;
    // We store the current path and any query params in the url and append that to the return URL.
    // We send the user to a specific route which will render a component that parses the token
    // for a user id and validates that the token has not expired.
    var returnPath = "".concat(returnPathQueryKey, "=").concat(pathname);
    var query = search !== "" ? "".concat(search, "&").concat(returnPath) : "?".concat(returnPath);
    var returnUrl = "".concat(origin).concat(urlPath, "#").concat(PageRoute.VALIDATE_TOKEN).concat(query);
    var encodedReturnUrl = encodeURIComponent(returnUrl);
    window.location.href = "".concat(authRedirectURL, "?returnUrl=").concat(encodedReturnUrl);
    return null;
};
// This component will render on the route "/validate-token" which the user will be redirected to
// after a successfull login at piab.com. If the token is valid and decoded successfully we navigate
// the user back to the original url that initiated the authentication procedure.
export var ValidateTokenAfterAuth = function () {
    var navigate = useNavigate();
    var _a = useAuthContext(), decodeToken = _a.decodeToken, isAuthenticated = _a.isAuthenticated;
    var hash = window.location.hash;
    var _b = __read(useState(), 2), returnParams = _b[0], setReturnParams = _b[1];
    var _c = __read(useState(), 2), returnPath = _c[0], setReturnPath = _c[1];
    useEffect(function () {
        if (!isAuthenticated || !returnPath) {
            return;
        }
        navigate({
            pathname: returnPath,
            search: returnParams,
        });
    }, [isAuthenticated, navigate, returnPath, returnParams]);
    useEffect(function () {
        var _a;
        var query = hash.split("?")[1];
        var queryParams = new URLSearchParams(query);
        var token = queryParams.get(tokenQueryKey);
        if (!token) {
            console.error("No token found in query after redirect");
            return;
        }
        decodeToken(token);
        var returnPathFromQuery = (_a = queryParams.get(returnPathQueryKey)) !== null && _a !== void 0 ? _a : "/";
        queryParams.delete(tokenQueryKey);
        queryParams.delete(returnPathQueryKey);
        var returnParamsFromQuery = queryParams.toString()
            ? "?".concat(queryParams.toString())
            : "";
        setReturnPath(returnPathFromQuery);
        setReturnParams(returnParamsFromQuery);
    }, [decodeToken, hash]);
    return null;
};
